import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import Graytextarea from '../../../components/Graytextarea'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const PoacGlobal = ({ patientDBdata, isSavingTheData,setPoacValueGlobal, patientID, MasterDiagnosisData, loggedUserProvider, setPatientDBdata, noteID }) => {

    const { getCallCenterQuestions } = useIndexedDB()
    const [freeTypeGlobal, setFreeTypeGlobal] = useState('')
    const [tempFreeTypeGlobal, setTempFreeTypeGlobal] = useState('')
    const[questionValue, setQuestionsValue] = useState([])
    console.log(questionValue,'questionValue')
    
    const [patientDiagnosis, setPatientDiagnosis] = useState([])
    useEffect(() => {
        const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
        setPatientDiagnosis(patientD)
    }, [])

    const getLatestDataForPoa = (allPatientHpiData, patientID,) => {

        const filtered = allPatientHpiData.filter((item) => {
            const patientData = item[patientID]
            // /  return patientData && patientData[noteID]
            return patientData
        })
        console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

        const latest = filtered.at(-1)
        console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
        return latest || null
    }



    const getCallCenterDatas = async (diagnosisList) => {


        // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
        // let data = await getCallCenterQuestions();
        // let allData = JSON.parse(data?.d);

        let allData = await getCallCenterQuestions();
        console.log('patinet id allData ', allData);

        const allPatientHpiData = allData?.Data?.map((item) => {
            return {
                ...JSON.parse(item?.JsonData),
                CreatedAt: item?.CreatedAt,
            };
        });

        const result = getLatestDataForPoa(allPatientHpiData, patientID);

        console.log("call center latest data ---> ", result);


        const convertedData = {};

        const callCenterData = result?.[patientID]?.CCENTER;
        const globalFreeType = result?.[patientID]?.globalFreeType
        if (callCenterData) {
            Object.keys(callCenterData).forEach((diagnosis) => {
                convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
                    question: q.label,
                    answer: q.answer,
                    freeType: q.freeType,
                    type: q?.type,
                    freewayRemark: q?.freewayRemark
                }));
            });
        }

        setFreeTypeGlobal(globalFreeType)
        setPoacValueGlobal(globalFreeType)
        setQuestionsValue(convertedData);
        console.log("Converted Call Center Data", convertedData);



        return convertedData;
    };
    useEffect(() => {
        if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
            getCallCenterDatas(patientDiagnosis)
        }
    }, [patientDiagnosis])

    if(!freeTypeGlobal){return null}

    return (
        <div className='d-flex align-items-start '>
            {/* <div style={{ minWidth: "23%" }}></div> */}
            <div className='w-100'>
                {/* POAC */}
                <GraytextareaAdjustable 
                onBlur={(e) => {
                    setPoacValueGlobal(tempFreeTypeGlobal)
                    // setFreeTypeGlobal(e.target.value)
                }}
                value={tempFreeTypeGlobal}
                onChange={(e) => {setTempFreeTypeGlobal(e.target.value)}}
                />
            </div>
        </div>
    )
}

export default PoacGlobal